__webpack_require__.p = "/handwriting-web/";